<template>
  <transition name="fade" mode="out-in" v-if="show">
    <div class="backloading">
      <div id="preloader">
        <span><img id="spin" :src="logoload" height="80px" /></span>
        <div id="loader"></div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "LogoLoading",
  props: {
    show: {
      type: Boolean,
      default() {
        return false;
      },
    },
    value: {
      type: Boolean,
      default() {
        return false;
      },
    },
    logo: {
      type: String,
      default() {
        return require("../assets/K1_Logo.png");
      },
    },
  },
  computed: {
    logoload() {
      return require("../assets/K1_Logo.png");
    },
  },
};
</script>

<style scoped>
body {
  background-color: #222;
}
.backloading {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0.7) 0%,
    rgba(255, 255, 255, 0.7) 100%
  );
}
#preloader span {
  color: white;
  position: fixed;
  top: 50%;
  left: 51%;
  /* bring your own prefixes */
  transform: translate(-60%, -50%);
}
#preloader {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
#preloader span {
  z-index: 99999;
  animation: pulse 2s linear infinite;
}
#loader {
  /*borda de fora*/
  display: block;
  position: relative;
  left: 50%;
  top: 50%;
  width: 150px;
  height: 150px;
  margin: -75px 0 0 -75px;
  border-radius: 50%;
  border: 3px solid transparent;
  border-top-color: #ff4646;
  -webkit-animation: spin 2s linear infinite;
  animation: spin 2s linear infinite;
}
#loader:before {
  /*borda de meio*/
  content: "";
  position: absolute;
  top: 5px;
  left: 5px;
  right: 5px;
  bottom: 5px;
  border-radius: 50%;
  border: 3px solid transparent;
  border-top-color: #d70000;
  -webkit-animation: spin 3s linear infinite;
  animation: spin 3s linear infinite;
}
#loader:after {
  /*borda de dentro*/
  content: "";
  position: absolute;
  top: 15px;
  left: 15px;
  right: 15px;
  bottom: 15px;
  border-radius: 50%;
  border: 3px solid transparent;
  border-top-color: #ff9b9b;
  -webkit-animation: spin 8s linear infinite;
  animation: spin 8s linear infinite;
}
@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes pulse {
  0% {
    opacity: 0.5;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0.5;
  }
}
</style>
